import React from "react";
import { Link } from "react-router-dom";

function New() {
  const data = [
    {
      id: 1,
      name: "Life Insurance",
      icon: "flaticon-insurance-1",
      desc:"Secure your family’s future with protection that supports them financially when it’s needed the most."
    },
    {
      id: 2,
      name: "Business Insurance",
      icon: "flaticon-insurance",
      desc:"Safeguard your business from unexpected losses, liabilities, and operational risks with reliable coverage."
    },
    {
      id: 3,
      name: "Health Insurance",
      icon: "flaticon-health-insurance",
      desc: "Get access to quality medical care and protect yourself from rising healthcare costs with comprehensive plans."
    },
    {
      id: 4,
      name: "Car Insurance",
      icon: "flaticon-car-insurance",
      desc:"Stay protected on the road with coverage for damage, accidents, theft, and third-party liabilities."
    },
    {
      id: 5,
      name: "Study Insurance",
      icon: "flaticon-study",
      desc:"Ensure a worry-free academic journey for students with coverage designed for education emergencies."
    },
    {
      id: 6,
      name: "Travel Insurance",
      icon: "flaticon-travel-insurance",
      desc: "Travel with confidence—your trips are protected against cancellations, delays, medical emergencies, and more."
    },
    {
      id: 7,
      name: "House Insurance",
      icon: "flaticon-insurance-3",
      desc: "Protect your home and valuable belongings from damage, theft, disasters, and unforeseen risks."
    },
    {
      id: 8,
      name: "Fire Insurance",
      icon: "flaticon-house",
      desc: "Get financial protection against fire-related damages to property, assets, or business premises."
    },
  ];
  return (
    <>
      <section className="service-two">
        <div className="container">
          <div className="sec-title text-center">
            <p className="sec-title__tagline">insurance services</p>

            <h3 className="sec-title__title">
              Take better insurance opportunity
            </h3>
          </div>

          <div className="row gutter-y-50">
            {data.map((item) => (
              <div className="col-md-6 col-lg-3" key={item.id}>
                <div className="service-card-two">
                  <div
                    className="service-card-two__bg"
                    // style={{
                    //   backgroundImage:
                    //     "url(assets/images/services/services-2-1.jpg)",
                    // }}
                  />

                  <div className="service-card-two__content">
                    <div className="service-card-two__icon">
                      <i className={`${item.icon}`} />
                    </div>

                    <h3 className="service-card-two__title">
                      <Link to="/insurancesdetails">{item.name}</Link>
                    </h3>
                    <p className="service-card-two__text">
                      {item.desc}
                    </p>

                    {/* <Link
                      to="/insurancesdetails"
                      className="service-card-two__link"
                    >
                      <i className="far fa-arrow-right" />
                    </Link> */}
                    <div className="service-card-two__shape" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default New;
